import { render, staticRenderFns } from "./CountdownComponent.vue?vue&type=template&id=a1a649a2&"
import script from "./CountdownComponent.vue?vue&type=script&lang=js&"
export * from "./CountdownComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports